module.exports = __webpack_public_path__ + "static/media/afterpay_badge.71e4117b.svg";